import React from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { Button, IconButton } from 'react-toolbox/lib/button';
import Spinner from '~/components/Spinner';
import Dropdown from 'react-toolbox/lib/dropdown';
// import InputFormatNumber from '~/components/InputFormatNumber';
import Tag from '~/components/Tag';
import Title from '~/components/Title';
import { create, update, remove, get } from '~/actions/rawMaterial';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

const types = [
  { value: 'items', label: 'Items' },
  { value: 'ounces', label: 'Ounces' },
  { value: 'grams', label: 'Grams' },
  { value: 'kilograms', label: 'Kilograms' },
  { value: 'inches', label: 'Inches' },
  { value: 'feet', label: 'Feet' },
  { value: 'meters', label: 'Meters' },
  { value: 'fluid ounces', label: 'Fluid Ounces' },
  { value: 'fluid gallons', label: 'Fluid Gallons' },
  { value: 'dry gallons', label: 'Dry Gallons' },
  { value: 'liters', label: 'Liters' },
  { value: 'milliliters', label: 'Milliliters' },
];

const rawMaterialCategories = [
  { value: null, label: 'Not Set' },
  { value: 'stickers', label: 'Stickers' },
  { value: 'bottle caps', label: 'Bottle Caps' },
  { value: 'bottles', label: 'Bottles' },
  { value: 'bags', label: 'Bags' },
  { value: 'boxes', label: 'Boxes' },
  { value: 'powders', label: 'Powders' },
  { value: 'liquids', label: 'Liquids' },
];

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: props.data.item && props.data.item.id,
      rawMaterial: {
        count: 0,
      },
      rawMaterialStock: [],
    };
  }

  componentDidMount() {
    if (this.state.loading) {
      get(this.props.dispatch, this.context.apiClient, this.props.data.item.id)
        .then(r => this.setState({
          loading: false,
          rawMaterial: r.data.rawMaterial,
          rawMaterialStock: r.data.rawMaterialStock,
        }));
    }
  }

  submit() {
    if (this.state.rawMaterial.id) {
      const { id, ...rest } = this.state.rawMaterial;
      return update(this.props.dispatch, this.context.apiClient, id, rest)
        .then(() => this.context.dialogClose(this.props.dialogId));
    }

    return create(this.props.dispatch, this.context.apiClient, this.state.rawMaterial)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onCreate && this.props.data.onCreate());
  }

  remove() {
    remove(this.props.dispatch, this.context.apiClient, this.state.rawMaterial.id)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onRemove && this.props.data.onRemove());
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content} style={{ width: '600px', overflow: 'visible' }}>
            <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
              {this.state.loading && <Spinner />}
            </div>
            {!this.state.loading && <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <Input
                label="Name"
                required
                value={this.state.rawMaterial.name}
                onChange={v =>
                  this.setState({ rawMaterial: { ...this.state.rawMaterial, name: v } })}
              />
              <Dropdown
                auto={false}
                label="Material unit"
                required
                onChange={v =>
                  this.setState({ rawMaterial: { ...this.state.rawMaterial, type: v } })}
                source={types}
                value={this.state.rawMaterial.type}
              />
              <Dropdown
                auto={false}
                label="Category"
                onChange={v =>
                  this.setState({ rawMaterial: { ...this.state.rawMaterial, category: v } })}
                source={rawMaterialCategories}
                value={this.state.rawMaterial.category || null}
              />
              <Input
                type="text"
                label="Notes"
                multiline
                value={this.state.rawMaterial.notes || ''}
                onChange={v =>
                  this.setState({ rawMaterial: { ...this.state.rawMaterial, notes: v } })}
              />
              {this.state.rawMaterial.id && <Button
                label="Remove raw material"
                primary
                style={{ float: 'right' }}
                onClick={() => this.context.dialogPush('message', { content: 'Are you sure?', onConfirm: () => this.remove() })}
              />}
              <Button label={this.state.rawMaterial.id ? 'Save' : 'Create'} type="submit" primary raised />
            </form>}
            <br />
            <Title>Locations with stock</Title>
            <br />
            {this.state.rawMaterialStock.map(rawMaterialStock => (<div key={rawMaterialStock.location.id} style={{ display: 'flex' }}>
              <span style={{ flexGrow: 1 }}>
                <Tag type={rawMaterialStock.location.type} id={rawMaterialStock.location.id} />
              </span>
              <span>{rawMaterialStock.count}</span>
            </div>))}
            {this.state.rawMaterialStock.length === 0 && <div>No locations with stock</div>}
            {this.state.rawMaterial.removed && <div className={style.removed}>REMOVED</div>}
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/RawMaterial/index.js